module.exports = __webpack_public_path__ + "img/default-user.436a5d67.svg";